export const SET_LAYOUT_SIDE_BAR_COLLAPSED = 'SET_LAYOUT_SIDE_BAR_COLLAPSED';
export const SET_MESSAGE_CENTER_COLLAPSED = 'SET_MESSAGE_CENTER_COLLAPSED';

interface SetSideBarCollapsed {
  type: typeof SET_LAYOUT_SIDE_BAR_COLLAPSED;
  collapsed: boolean;
}

interface SetMessageCenterCollapsed {
  type: typeof SET_MESSAGE_CENTER_COLLAPSED;
  collapsed: boolean;
}

export type LayoutSettingsActionTypes =
  | SetSideBarCollapsed
  | SetMessageCenterCollapsed;
